import React from "react";
import { useRecoilValue } from "recoil";
// import secretLogo from "../../../assets/images/secret_swap_2.png";
import secretLogoDark from "../../../assets/images/secret_swap_2_logo5.png";
import secretLogoLight from "../../../assets/images/secret_swap_2_logo4.png";
import { themeState } from "../../../context/themeState";
// import secretLogo from "../../../assets/images/secret_swap_2_logo2.png";
import "./logo.css";

const TextLogo = () => {
  const theme = useRecoilValue(themeState);
  return (
    <div className="text-logo-container">
      <img
        className="text-logo-img"
        src={theme === "Dark" ? secretLogoDark : secretLogoLight}
      />
      <h3>SecretSwap 2.0</h3>
    </div>
  );
};

export default TextLogo;
